var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6445 0.975098H1.35097C0.714171 0.975098 0.199249 1.47783 0.199249 2.09939V15.4478C0.199249 16.0693 0.714171 16.5751 1.35097 16.5751H14.6445C15.2813 16.5751 15.7992 16.0693 15.7992 15.4508V2.09939C15.7992 1.47783 15.2813 0.975098 14.6445 0.975098ZM4.82745 14.2686H2.51183V6.82205H4.82745V14.2686ZM3.66964 5.80744C2.9262 5.80744 2.32597 5.20721 2.32597 4.46682C2.32597 3.72643 2.9262 3.12619 3.66964 3.12619C4.41003 3.12619 5.01026 3.72643 5.01026 4.46682C5.01026 5.20416 4.41003 5.80744 3.66964 5.80744ZM13.4928 14.2686H11.1802V10.6489C11.1802 9.78666 11.165 8.67455 9.97667 8.67455C8.77316 8.67455 8.59034 9.61604 8.59034 10.588V14.2686H6.28081V6.82205H8.49894V7.83971H8.52941C8.83714 7.25471 9.59277 6.63619 10.7171 6.63619C13.0601 6.63619 13.4928 8.17791 13.4928 10.1828V14.2686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c67951d6018f3679f212ba3dcfa127f2.svg";
export { ForwardRef as ReactComponent };